module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-contain"
  }, [_c('v-text-field', {
    staticClass: "input-text",
    attrs: {
      "value": _vm.value,
      "v-mask": _vm.mask,
      "input-value": _vm.value,
      "append-icon": _vm.type === 'password' ? _vm.show ? 'mdi-eye' : 'mdi-eye-off' : '',
      "height": "44",
      "show_password": _vm.show,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "content-class": "input-text__content",
      "type": _vm.type === 'password' && _vm.show ? 'password' : _vm.type === 'password' && !_vm.show ? 'text' : _vm.type,
      "rules": _vm.rules || [],
      "hide-details": "auto",
      "clearable": _vm.clearable,
      "disabled": _vm.disabled,
      "label": _vm.label,
      "color": _vm.color
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      },
      "click:append": function($event) {
        _vm.show = !_vm.show
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.hint))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6928151d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/UiInput.vue
// module id = 361
// module chunks = 2